import React, { useState, useRef } from 'react';
import {errorToastOptions} from "../ErrorToast";
import {
    IonList,
    IonItem,
    IonLabel,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSearchbar,
    IonAlert,
    IonIcon, IonItemDivider, IonRefresher, IonRefresherContent, IonBadge,
    useIonRouter,
    useIonViewWillEnter, IonButton, useIonToast
} from '@ionic/react';
import { add } from 'ionicons/icons';
import {createUser, getUsers} from "../../repositories/adminUserRepository";
import {useInfiniteQuery, useQueryClient} from "@tanstack/react-query";

const AdminEntityList = () => {
    const [searchText, setSearchText] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const queryClient = useQueryClient();
    const [presentToast] = useIonToast();

    const usersQuery = useInfiniteQuery({
        queryKey: ['admin', 'users', {searchText}],
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) => lastPage.length > 0 ? pages.length + 1 : undefined,
        queryFn: ({pageParam}) => getUsers(searchText, pageParam)
    });

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        usersQuery.refetch();
    })

    const reload = async (event) => {
        await usersQuery.refetch();
        event.detail.complete();
    };

    const loadMore = async (event) => {
        await usersQuery.fetchNextPage();
        event.target.complete();
    };

    const handleSave = async (name, email) => {
        let user;
        try {
            user = await createUser(name, email);
        } catch (e) {
            const message = typeof e.response?.data === 'string' && e.response.data ? e.response.data : "Failed to create user";
            await presentToast(errorToastOptions(message));
            return;
        }
        await queryClient.invalidateQueries({queryKey: ['admin', 'users']});
        navigateToEntityDetails(user.id);
    };

    const handleSearch = async (event) => {
        setSearchText(event.detail.value);
        // setTimeout(() => loadInitialEntities(event.detail.value));
    };

    const openCreateAlert = () => {
        setShowAlert(true);
    };

    const navigateToEntityDetails = (id) => {
        router.push('/admin/users/' + id);
    }

    const showEnabledBadge = (user) => {
        if (user.disabled) {
            return <IonBadge slot={"end"} color="danger">Disabled</IonBadge>
        }

        return <IonBadge slot={"end"} color="success">Enabled</IonBadge>
    }

    return (
            <>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonItemDivider sticky className="access-list-search-bar">
                    <IonButton className="ion-margin-start" fill="outline" slot="start" onClick={openCreateAlert}>
                        <IonIcon icon={add} />
                    </IonButton>
                    <IonSearchbar
                        debounce={1000}
                        mode="ios"
                        enterkeyhint="search" inputmode="search" onIonInput={(ev) => handleSearch(ev)}></IonSearchbar>
                </IonItemDivider>

                <IonList>
                    {usersQuery.data?.pages
                        .flatMap(data => data)
                        .map(entity => (
                            <IonItem button key={entity.id} onClick={() => navigateToEntityDetails(entity.id)}>
                                <IonLabel>{entity.name}</IonLabel>
                                {showEnabledBadge(entity)}
                            </IonItem>
                        ))}
                </IonList>

                <IonInfiniteScroll onIonInfinite={loadMore} threshold="100px" disabled={!usersQuery.hasNextPage}>
                    <IonInfiniteScrollContent loadingText="Loading more..."></IonInfiniteScrollContent>
                </IonInfiniteScroll>

                <IonAlert
                    isOpen={showAlert}
                    onDidDismiss={() => setShowAlert(false)}
                    header="Create User"
                    inputs={[
                        {
                            name: 'name',
                            type: 'text',
                            placeholder: 'Enter user name',
                        },
                        {
                            name: 'email',
                            type: 'text',
                            placeholder: 'Enter user email',
                        }
                    ]}
                    buttons={[
                        { text: 'Cancel', role: 'cancel', handler: () => setShowAlert(false) },
                        { text: 'Create', handler: (data) => handleSave(data.name, data.email) }
                    ]}
                />
            </>
    );
};

export default AdminEntityList;